import { OperacoesWebAPI } from '../../utils/global';
import api from '../api'
export const dadosCadastraisService = {

    getByNomeSemelhante: (nome: string = "") => {
        return api.get(`${OperacoesWebAPI.DadosCadastrais}/GetByNomeSemelhante`, { params: { nome } })
            .then((res) => res)
            .catch(err => err)
    },

    post: (dadosCadastrais: any) => {
        return api.post(`${OperacoesWebAPI.DadosCadastrais}`, dadosCadastrais)
            .then((response: any) => { return response.data });
    },

    put: (dadosCadastrais: any) => {
        return api.put(`${OperacoesWebAPI.DadosCadastrais}`, dadosCadastrais)
            .then((response: any) => { return response.data })
            .catch(err => err);
    },

    delete: (dadosCadastraisID: number) => {
        return api.delete(`${OperacoesWebAPI.DadosCadastrais}?id=${dadosCadastraisID}`)
            .then((response: any) => { return response.data });
    },

    ativarInativar: (dadosCadastraisID: string, ativo: boolean) => {
        return api.put(`${OperacoesWebAPI.DadosCadastrais}/ativarInativar?dadosCadastraisID=${dadosCadastraisID}&ativo=${ativo}`)
            .then((response: any) => { return response.data });
    },
} 
